import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const FirstpayHostedPaymentContainer = styled.div`
  margin: ${primitive.$spacing2} 0;
  width: 100%;
  height: 850px;
`;
